export default __webpack_public_path__ + "static/media/field-number.b457b3af.svg";